import type { CityConfig } from "../city-template/types";

export const hagerstownConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Hagerstown",
  state: "Maryland",
  stateAbbr: "MD",
  slug: "hagerstown",
  route: "/cities/hagerstown",
  title: "Emergency Passport Hagerstown, MD — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Hagerstown, Maryland — as fast as 24 hours. Fast passport renewal and new passport applications for Hagerstown, Williamsport, Boonsboro, and Clear Spring residents. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Hagerstown, MD",
  heroSubtitle: "Hagerstown travelers — from the historic downtown to the I-81 corridor to the Pennsylvania border — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated courier service serving all of Washington County and Western Maryland.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Historic%20downtown%20Hagerstown%20Maryland%20main%20street%20with%20charming%20brick%20buildings%2C%20historic%20courthouse%2C%20tree-lined%20streets%2C%20warm%20afternoon%20sunlight%2C%20small-town%20American%20architecture%2C%20clean%20and%20inviting%20downtown%20district%2C%20no%20visible%20text%20or%20people%2C%20warm%20earth%20tones%20and%20soft%20golden%20lighting%2C%20professional%20photography%20style&width=1800&height=700&seq=hagerstown-hero-001&orientation=landscape",
  heroImageAlt: "Historic downtown Hagerstown Maryland with charming brick buildings and warm afternoon sunlight",
  geoPosition: "39.6418;-77.7200",
  geoPlacename: "Hagerstown, Maryland",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Washington DC Passport Agency",
    address: "600 19th St NW, 1st Floor, Washington, DC 20006",
    distance: "Approximately 75–85 minutes from Hagerstown via I-270 S and I-495 S",
  },
  nearbyCitiesZips: [
    { name: "Hagerstown", zips: "21740, 21741, 21742, 21746, 21747, 21749, 21750" },
    { name: "Williamsport", zips: "21795" },
    { name: "Funkstown", zips: "21734" },
    { name: "Boonsboro", zips: "21713" },
    { name: "Clear Spring", zips: "21722" },
    { name: "Halfway", zips: "21740" },
    { name: "Maugansville", zips: "21767" },
    { name: "Smithsburg", zips: "21783" },
    { name: "Keedysville", zips: "21756" },
    { name: "Sharpsburg", zips: "21782" },
    { name: "Cascade", zips: "21719" },
    { name: "Cavetown", zips: "21720" },
    { name: "Leitersburg", zips: "21742" },
    { name: "Fountainhead-Orchard Hills", zips: "21742" },
    { name: "St. James", zips: "21740" },
    { name: "Paramount-Long Meadow", zips: "21742" },
    { name: "Chambersburg, PA", zips: "17201, 17202" },
    { name: "Martinsburg, WV", zips: "25401, 25404, 25405" },
    { name: "Greencastle, PA", zips: "17225" },
    { name: "Waynesboro, PA", zips: "17268" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier for Hagerstown and Western Maryland departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-road-map-line", title: "I-81 Corridor Coverage", desc: "Serving the tri-state area of Maryland, Pennsylvania, and West Virginia" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — no trip to downtown DC" },
  ],
  internalLinks: [
    { name: "Expedited passport in Frederick, MD", route: "/cities/frederick-md" },
    { name: "Emergency passport help in Baltimore, MD", route: "/cities/baltimore" },
    { name: "Urgent passport services in Gaithersburg, MD", route: "/cities/gaithersburg" },
    { name: "Maryland passport services overview", route: "/states/maryland" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Hagerstown, Maryland remotely via secure registered courier. We do not have a walk-in office in Hagerstown — our registered couriers hand-deliver your documents to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Western Maryland travelers without the long drive to downtown DC.",
  fpcOfficeAddress: "7272 Wisconsin Ave, Bethesda, MD 20814",
  fpcOfficeDistance: "Serving Hagerstown, Williamsport, Boonsboro, Clear Spring, and all of Washington County",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Washington County and Western Maryland. From the historic downtown streets of Hagerstown to the rolling hills of Boonsboro, from the Antietam battlefield area to the Pennsylvania border communities of Chambersburg and Waynesboro — we serve all of the I-81 corridor and tri-state region.",
  nearbyCitiesIntro: "We serve Hagerstown and nearby communities including Williamsport, Funkstown, Boonsboro, Clear Spring, Halfway, Maugansville, Smithsburg, Keedysville, Sharpsburg, and all of Washington County. We also serve cross-border travelers from Chambersburg, Greencastle, and Waynesboro in Pennsylvania, as well as Martinsburg in West Virginia.",
  howItWorksIntro: "Most Hagerstown travelers complete everything online and ship documents overnight. No need to drive 75–85 minutes to downtown DC through I-270 traffic.",
  mistakesIntro: "Hagerstown and Western Maryland travelers often face unique challenges due to distance from major passport agencies. Here are the most common mistakes we see from tri-state area travelers.",
  testimonialsIntro: "Hagerstown travelers — from historic preservation professionals to agricultural workers to cross-border commuters — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Hagerstown, MD? Here are the most common ones we hear from Western Maryland travelers.",
  statePageRoute: "/states/maryland",
  statePageName: "Maryland",
  dmvWebsite: "https://mva.maryland.gov",
  dmvLabel: "Maryland MVA — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Perfect for Western Maryland travel deadlines", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive 75–85 min to downtown DC", "Full day commitment — challenging for working professionals"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Hagerstown travelers with immediate departure needs — as fast as 24 hours. Perfect for cross-border business trips, last-minute family travel, and unexpected emergencies.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Cross-border travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Hagerstown adults with a passport issued within the last 15 years.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to Hagerstown address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Hagerstown residents and families — including students and agricultural workers.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Hagerstown residents who lost their passport before travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Hagerstown families with kids traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Hagerstown residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Hagerstown MD", description: "Urgent passport processing for Hagerstown Maryland travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Hagerstown MD", description: "Fast passport renewal for Hagerstown Maryland residents with a previously-issued passport." },
    { name: "First-Time Passport Hagerstown MD", description: "New passport application services for Hagerstown Maryland residents applying for their first passport." },
    { name: "Child Passport Hagerstown MD", description: "Minor passport services for Hagerstown Maryland families with children under 16." },
  ],
  testimonials: [
    {
      name: "Robert H.",
      location: "Boonsboro, MD",
      rating: 5,
      text: "Had a family emergency in Canada and needed to cross the border in 4 days. Fast Passport Center handled everything from my home in Boonsboro. Passport arrived in 36 hours. Cannot recommend enough for rural Maryland residents.",
      service: "Emergency Passport",
    },
    {
      name: "Sarah M.",
      location: "Hagerstown, MD",
      rating: 5,
      text: "My daughter's study abroad program to Germany started in 10 days and we discovered her passport was expired. Fast Passport Center reviewed our documents, caught a photo issue, and had her new passport in 5 days.",
      service: "Child Passport Renewal",
    },
    {
      name: "David K.",
      location: "Williamsport, MD",
      rating: 5,
      text: "Business trip to Mexico with a week's notice. Living in Williamsport, I thought I'd have to drive to DC. Fast Passport Center shipped everything overnight and my passport was back in 3 days. No DC trip needed.",
      service: "Emergency Passport",
    },
    {
      name: "Jennifer L.",
      location: "Clear Spring, MD",
      rating: 5,
      text: "Renewed my passport for a Caribbean cruise. The process was so simple — filled everything out online, shipped from the Hagerstown UPS Store, and had it back in under 2 weeks. Great for rural Maryland folks.",
      service: "Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "hagerstown-1",
      name: "Hagerstown Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "64 W Franklin St",
      city: "Hagerstown",
      state: "MD",
      zip: "21740",
      phone: "(301) 733-6510",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Hagerstown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary downtown acceptance facility for Hagerstown and Washington County. Appointments required — book 1–2 weeks in advance. Street parking available.",
      icon: "ri-mail-line",
    },
    {
      id: "hagerstown-2",
      name: "Washington County Clerk's Office",
      type: "County Clerk Passport Acceptance",
      address: "100 W Washington St",
      city: "Hagerstown",
      state: "MD",
      zip: "21740",
      phone: "(240) 313-2200",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Downtown Hagerstown, near the courthouse complex",
      website: "https://www.washco-md.net/",
      websiteLabel: "Washington County",
      notes: "County-level facility with full passport acceptance. Extended hours compared to post office. Convenient for downtown Hagerstown residents and workers.",
      icon: "ri-government-line",
    },
    {
      id: "hagerstown-3",
      name: "Halfway Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1730 Dual Hwy",
      city: "Hagerstown",
      state: "MD",
      zip: "21740",
      phone: "(301) 797-2680",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Halfway area, approximately 3 miles east of downtown Hagerstown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for eastern Hagerstown and Halfway residents. Call to confirm current passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "hagerstown-4",
      name: "Chambersburg Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3615 Philadelphia Ave",
      city: "Chambersburg",
      state: "PA",
      zip: "17201",
      phone: "(717) 263-5735",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Chambersburg, PA — approximately 25 miles north of Hagerstown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Alternative for northern Washington County residents and Pennsylvania cross-border travelers. Appointments required.",
      icon: "ri-mail-line",
    },
    {
      id: "hagerstown-5",
      name: "Martinsburg Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "135 W Martin St",
      city: "Martinsburg",
      state: "WV",
      zip: "25401",
      phone: "(304) 263-5484",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Martinsburg, WV — approximately 20 miles southwest of Hagerstown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Alternative for southwestern Washington County residents and West Virginia cross-border travelers.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited DC slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 75–85 min drive to downtown DC", fpc: "No — ship from Hagerstown" },
    { feature: "Cross-Border Travel Support", agency: "No flexibility for rural needs", fpc: "Yes — we handle PA and WV cross-border cases" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Western Maryland residents often underestimate the distance to the DC passport agency. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Local photo services in Hagerstown and the tri-state area sometimes produce photos that meet general ID requirements but not passport standards. Passport photos must be exactly 2x2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 rejection reasons at Hagerstown and Washington County acceptance facilities.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Booking the Acceptance Facility Early",
      description: "Hagerstown Post Office appointments fill up fast, especially during summer travel season and before school breaks. Book 2–3 weeks ahead.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Government fees change periodically. Always verify current fees before submitting — incorrect payment means starting over.",
    },
    {
      icon: "ri-time-line",
      title: "Underestimating Routine Processing Time",
      description: "Western Maryland residents often assume 4–6 weeks is enough. Routine processing takes 6–13 weeks. If your travel is within 10 weeks, use expedited service.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from your home in Hagerstown, Williamsport, or Boonsboro." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx location near downtown Hagerstown or along the I-81 corridor." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Hagerstown address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Hagerstown, MD?", a: "Fast Passport Center offers emergency passport processing in Hagerstown, Maryland in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Washington DC Passport Agency — without you needing to make the 75–85 minute drive through I-270 and I-495 traffic." },
    { q: "Does Hagerstown have its own passport agency?", a: "No — neither Hagerstown nor the state of Maryland has a regional passport agency. The closest facility is the Washington DC Passport Agency, approximately 75–85 minutes from Hagerstown via I-270 S and I-495 S. Fast Passport Center's courier service means Western Maryland residents never need to make that drive." },
    { q: "Can I get expedited passport services if I live in Boonsboro or Clear Spring?", a: "Absolutely. Fast Passport Center serves all of Washington County and Western Maryland including Boonsboro, Clear Spring, Williamsport, Funkstown, Halfway, Maugansville, Smithsburg, Keedysville, and Sharpsburg. We also serve cross-border travelers from Chambersburg, Greencastle, and Waynesboro in Pennsylvania, as well as Martinsburg in West Virginia." },
    { q: "How much does an expedited passport cost in Hagerstown, MD?", a: "Government fees are fixed: $130 for a first-time passport book or $130 + $60 expedite for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your departure timeline." },
    { q: "What airports do Hagerstown travelers use for international flights?", a: "Most Hagerstown residents fly internationally through Baltimore-Washington International Airport (BWI), approximately 75–85 minutes east via I-70 and I-695. Washington Dulles (IAD) and Reagan National (DCA) offer additional international connections. Hagerstown Regional Airport (HGR) offers domestic flights but limited international connections. Always verify your passport is valid for at least 6 months past your return date." },
    { q: "Can I get a passport for my whole family in Hagerstown?", a: "Yes. Fast Passport Center handles multi-passport cases for families in Hagerstown, Boonsboro, Williamsport, and all of Washington County. Whether you need child passports, renewals, or first-time applications for the whole family, we coordinate the process to ensure everyone is ready to travel." },
    { q: "Where is the closest passport acceptance facility to downtown Hagerstown?", a: "The Hagerstown Post Office at 64 W Franklin St is the primary downtown acceptance facility. The Washington County Clerk's Office at 100 W Washington St offers extended hours. The Halfway Post Office at 1730 Dual Hwy serves eastern Hagerstown. All require appointments — book 1–2 weeks ahead." },
    { q: "How do I know if I need expedited or routine passport processing?", a: "If your travel is within 10 weeks, use expedited service. If your travel is within 2–3 weeks, use emergency expedited service. Routine processing takes 6–13 weeks and is only suitable for travel more than 3 months away. Western Maryland residents should plan ahead, especially for cross-border travel and summer vacations." },
  ],
  photoLocations: [
    { name: "Walgreens — Hagerstown", address: "1750 Massey Blvd, Hagerstown, MD 21740", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/store-locator" },
    { name: "CVS Pharmacy — Hagerstown", address: "1770 Dual Hwy, Hagerstown, MD 21740", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/store-locator/cvs-pharmacy-locations" },
    { name: "UPS Store — Hagerstown", address: "1770 Dual Hwy, Hagerstown, MD 21740", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM", website: "https://www.theupsstore.com/tools/find-a-store" },
    { name: "FedEx Office — Hagerstown", address: "1710 Massey Blvd, Hagerstown, MD 21740", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://local.fedex.com/" },
  ],
  dmvLocations: [
    { name: "MVA — Hagerstown", address: "18306 Col Henry K Douglas Dr, Hagerstown, MD 21740", hours: "Mon–Fri: 8:30AM–4:30PM", note: "Full-service MVA for Washington County and Western Maryland residents. REAL ID processing available.", featured: true },
    { name: "MVA — Frederick", address: "1601 Bowmans Farm Rd, Frederick, MD 21701", hours: "Mon–Fri: 8:30AM–4:30PM", note: "Alternative MVA location for eastern Washington County residents. Approximately 30 minutes from Hagerstown.", featured: false },
  ],
  airports: [
    {
      code: "BWI",
      name: "Baltimore-Washington International Thurgood Marshall",
      distance: "75–85 minutes from Hagerstown via I-70 E and I-695 N",
      address: "7050 Friendship Rd, Baltimore, MD 21240",
      note: "Primary international departure airport for Hagerstown travelers. Direct flights to London, Cancun, Reykjavik, and the Caribbean. Extensive domestic connections.",
      flightUrl: "https://www.bwiairport.com/",
      flightLabel: "BWI Flight Info",
      featured: true,
    },
    {
      code: "IAD",
      name: "Dulles International (Washington DC)",
      distance: "65–75 minutes from Hagerstown via I-70 E and I-270 S",
      address: "1 Saarinen Cir, Dulles, VA 20166",
      note: "Alternative for long-haul international flights to Europe and Asia. United Airlines hub.",
      flightUrl: "https://www.flydulles.com/",
      flightLabel: "IAD Flight Info",
      featured: false,
    },
    {
      code: "DCA",
      name: "Reagan National (Washington DC)",
      distance: "75–85 minutes from Hagerstown via I-70 E and I-270 S",
      address: "2401 Smith Blvd, Arlington, VA 22202",
      note: "Secondary option for international connections via domestic hubs. Major business travel airport.",
      flightUrl: "https://www.flyreagan.com/",
      flightLabel: "DCA Flight Info",
      featured: false,
    },
  ],
};